import { LetterResDto } from '../dtos/letterResDTO';
import { RegisterResDTO } from '../dtos/registerResDTO';
import { RegisterType } from '../enums/registerType';

export function getRegisterCode(type: string) {
	if (
		type === '1 HI' ||
		type === '1.8.1 HI' ||
		type === '1.0:1.8.1.255 HI' ||
		type === 'RRA+HI1DKWH HI'
	) {
		return '1.8.1';
	} else if (
		type === '2 LO' ||
		type === '1.8.2 LO' ||
		type === '1.0:1.8.2.255 LO' ||
		type === 'RRA+LO1DKWH LO'
	) {
		return '1.8.2';
	} else if (
		type === '1R HI' ||
		type === '2.8.1 HI' ||
		type === '1.0:2.8.1.255 HI' ||
		type === 'RRA-HI1DKWH HI' ||
		type === 'RRA-HI1DKWH NU'
	) {
		return '2.8.1';
	} else if (
		type === '2R LO' ||
		type === '2.8.2 LO' ||
		type === '1.0:2.8.2.255 LO' ||
		type === 'RRA-LO1DKWH LO' ||
		type === 'RRA-LO1DKWH NU'
	) {
		return '2.8.2';
	}
}

export function getMetersRefNumberFromRegister(
	registerId: string,
	letter?: LetterResDto | null,
) {
	for (const meter of letter?.meters || []) {
		if (
			meter.registers.some((register) => {
				return register.mroId === registerId;
			})
		) {
			return meter.meterNumber;
		}
	}
}

export function getRegister(
	registerId: string,
	letter?: LetterResDto | null,
): RegisterResDTO | undefined {
	for (const meter of letter?.meters || []) {
		const item = meter.registers.find((register) => {
			return register.mroId === registerId;
		});
		if (item) {
			return item;
		}
	}
}

export function getMetersRefNumber(letter?: LetterResDto | null) {
	const result = { gas: '', electricity: '' };
	letter?.meters.forEach((meter) => {
		if (
			meter.registers.some((register) => {
				return getRegisterType(register.type) === RegisterType.GAS;
			})
		) {
			result.gas = meter.meterNumber;
		} else {
			result.electricity = meter.meterNumber;
		}
	});
	return result;
}
export function getRegisterType(type: string): RegisterType {
	if (type === 'TH') {
		return RegisterType.ELECTRICITY;
	} else if (type === 'RRA-HI1DKWH NU') {
		return RegisterType.ELECTRICITY_INJECTION_DAY;
	} else if (type === 'RRA-LO1DKWH NU') {
		return RegisterType.ELECTRICITY_INJECTION_NIGHT;
	} else if (type === 'NU') {
		return RegisterType.ELECTRICITY_NOT_USED;
	} else if (type === 'HI') {
		return RegisterType.ELECTRICITY_DAY;
	} else if (type === 'LO') {
		return RegisterType.ELECTRICITY_NIGHT;
	} else if (type === 'EX') {
		return RegisterType.ELECTRICITY_EX_NIGHT;
	} else if (
		type === '1 HI' ||
		type === '1.8.1 HI' ||
		type === '1.0:1.8.1.255 HI' ||
		type === 'RRA+HI1DKWH HI'
	) {
		return RegisterType.ELECTRICITY_DAY_PLUS;
	} else if (
		type === '2 LO' ||
		type === '1.8.2 LO' ||
		type === '1.0:1.8.2.255 LO' ||
		type === 'RRA+LO1DKWH LO'
	) {
		return RegisterType.ELECTRICITY_NIGHT_PLUS;
	} else if (
		type === '1R HI' ||
		type === '2.8.1 HI' ||
		type === '1.0:2.8.1.255 HI' ||
		type === 'RRA-HI1DKWH HI'
	) {
		return RegisterType.ELECTRICITY_DAY_MIN;
	} else if (
		type === '2R LO' ||
		type === '2.8.2 LO' ||
		type === '1.0:2.8.2.255 LO' ||
		type === 'RRA-LO1DKWH LO'
	) {
		return RegisterType.ELECTRICITY_NIGHT_MIN;
	} else {
		return RegisterType.GAS;
	}
}

export const isOkRegisterIndex = (register: RegisterResDTO, index: number) =>
	index >= register.expectedMinValue && index <= register.expectedMaxValue;

export const isOrangeRegisterIndex = (
	register: RegisterResDTO,
	index: number,
) =>
	(index >= register.expectedMinRedValue &&
		index <= register.expectedMinValue) ||
	(index >= register.expectedMaxValue && index <= register.expectedMaxRedValue);

export const isRedRegisterIndex = (register: RegisterResDTO, index: number) =>
	!isOkRegisterIndex(register, index) &&
	!isOrangeRegisterIndex(register, index);
